import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { api, type HistoryItem } from '../lib/api'
import { Screen, Button } from '../components/Layout'

/** PRD v1.1 §12.2 — the primary action dominates; recent session gives re-entry. */
export default function Home({ displayName }: { displayName: string | null }) {
  const navigate = useNavigate()
  const [recent, setRecent] = useState<HistoryItem | null>(null)

  useEffect(() => {
    api
      .history(1)
      .then((rows) => setRecent(rows[0] ?? null))
      .catch(() => setRecent(null))
  }, [])

  return (
    <Screen title="EV 充電服務">
      {displayName && <p className="greeting">您好，{displayName}</p>}

      <Button onClick={() => navigate('/charging/start')}>開始充電</Button>

      {recent && (
        <section className="card">
          <h2>最近充電</h2>
          <p className="recent-station">{recent.station_name ?? recent.evse_id}</p>
          <p className="recent-meta">
            {recent.energy_kwh ? `${recent.energy_kwh} kWh` : '—'}
            {recent.duration_seconds
              ? ` · ${Math.round(recent.duration_seconds / 60)} 分鐘`
              : ''}
          </p>
        </section>
      )}

      <div className="grid">
        <Button variant="secondary" onClick={() => navigate('/history')}>
          充電紀錄
        </Button>
        {/* Phase 2 (§48). Disabled rather than hidden so the roadmap is legible. */}
        <Button variant="secondary" disabled>
          優惠活動
        </Button>
        <Button variant="secondary" disabled>
          付款方式
        </Button>
        <Button variant="secondary" disabled>
          客服申訴
        </Button>
      </div>
    </Screen>
  )
}
